import usePrivateAxios from '@/common/api/usePrivateAxios'
import { ErrorResponse } from '@/common/types/errorResponse'
import { EstablishmentInfrastructureValidationSchema } from '@/features/maintenance/establishmentInfrastructures/schemas/create.schema'
import { useMutation } from '@tanstack/react-query'

interface UseCreateEstablishmentInfrastructureProps {
  onSuccess: () => void
  onError: (error: ErrorResponse) => void
}

export const useCreateEstablishmentInfrastructure = ({
  onSuccess,
  onError,
}: UseCreateEstablishmentInfrastructureProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['createEstablishmentInfrastructure'],
    mutationFn: async (form: EstablishmentInfrastructureValidationSchema) => {
      const establishment_infrastructure = {
        ...form,
      }

      return privateAxios.post('/maintenance/establishment_infrastructures', establishment_infrastructure)
    },
    onSuccess,
    onError,
  })
}
